export default __webpack_public_path__ + "static/media/odisPreview.22c3e667.png";